module.exports = __webpack_public_path__ + "d2f970bd864e6568b960018a658c1d25.svg";